import { AbstractControl, ValidationErrors } from '@angular/forms';
import IBAN from 'iban';

const BIC_PATTERN = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export function iban(control: AbstractControl): ValidationErrors | null {
  // only validate if user has already input some text
  const hasError = control.value && !IBAN.isValid(control.value);
  return hasError ? {iban: true} : null;
}

export function bic(control: AbstractControl): ValidationErrors | null {
  // only validate if user has already input some text
  const hasError = control.value && !BIC_PATTERN.test(control.value);
  return hasError ? {bic: true} : null;
}
